<template>
    <div class="listmain ">
         <h1 class="firTitle">标准请求</h1>
              <p>OrionOS通过 HTTP协议发送post请求到用户技能网关，技能网关应在5秒内响应结果，如未能及时响应，OrionOS将抛弃该请求
              </p>
              <h5 class="thirdTitle">请求头信息：</h5>
              <p>HTTP Header
                <br>POST :  /intent/invoke HTTP/1.1
                <br>Content-Type : application/json;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br> Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>
               <p>Request Form Syntax
              </p>
              <h5 class="codeTitle">IntentRequest Example 技能语音服务</h5>
               <highlight-code lang="javascript">
                {
                    "vserion": "0.2.0", //Type:String,系统版本号
                    "session": {//Type:JSONObject
                        "sessionId": "3123132123"//Type:String,猎户语音服务生成的唯一会话ID，每次变化
                        "attributes":{//Type:JSONObject,会话属性，会话结束后自动清空(SkillSession.END)，用户会话未结束(SkillSession.Begin\SkillSession.Running)，会将用户上一轮中的信息带回
                            "a":"b",
                            "c":"d"
                        },
                        "application": {//Type:JSONObject,描述会话中应用的信息，包括接入的客户端
                            "client":{//Type:JSONObject,接入猎户OS的客户端使用的clientID
                                "clientId":"orion.ovs.client.1501826808675",//Type:String,猎户语音系统 （OVS）ClientID
                                "ucenter":{//Type:JSONObject
                                    "clientId":"orion.ucenter.5ae7ab0c5a1cebcf"//Type:String,该猎户语音系统（OVS）客户端关联的用户中心ClientID，该字段可以内部控制
                                    "secret":"xxerwerewrewrewr"//Type:String,该猎户语音系统（OVS）客户端关联的用户中心Secret，该字段可以内部控制
                                }
                            },
                            "skill":{//Type:JSONObject
                                "skillId":"orion.ovs.skill.1504611578838",//Type:String,该次请求所访问的技能的skillID
                                "linkAccount":{//Type:JSONObject,该次请求所访问的技能skill下的资源鉴权信息，该部分信息
                                    "15":{//Type:JSONObject,资源平台的ID
                                        "xxxx":"yyyy"//Type:String
                                        ...//详细的信息和资源平台对应
                                    }
                                }
                            }
                        },
                        "user": {//Type:JSONObject
                            "isLogin":true, //Type:Boolean,用户是否处于登录状态
                            "openId":"2WzaJr2xScwL5Lj7tiIcKQ==", //Type:String,分配给第三方使用的UserID
                            "userId":"1234455", //Type:String,系统内部的唯一ID，通常情况下不会给第三方进行使用
                            "unionAccessToken":"esbCIsImlzcyI6Imh0dHA6Ly9hcGkuY2hpbGQuY21jbS5jb20iLCJleHAiOj" //Type:String,系统内部的用户登录凭证，通常情况下不会给第三方进行使用
                            "voiceprint":{ //Type:JSONObject,本次请求的声纹信息,前期没有
                                "voiceId":"xxxxx"//Type:String
                            },
                            "voiceprintPay":true/false//Type:Boolean,该用户是否可以进行声纹支付
                        },
                        "dialogCompatible": {//对话兼容字段,对外不可见
                            "requestPkg":{
                            }
                        }
                    },
                    "context": {//Type:JSONObject
                        "System":{//Type:JSONObject
                            "device": {//Type:JSONObject,设备相关信息
                                "deviceType": "",//Type:String,设备类型
                                "deviceId": "",//Type:String,设备ID
                                "lat": "",//Type:String,经度
                                "lng": "",//Type:String,维度
                                "version": "",//Type:String,当前APP版本号
                            },
                            "params":{}//Type:JSONObject,该数据透传小雅音箱的公共参数
                        }
                    }
                    //IntentRequest
                   "request": {//Type:JSONObject
                        "type": "IntentRequest",//Type:String
                        "nlu":{}//Type:JSONObject,详见NLU协议（跳转到nlu协议文档）,
                        "asr": {//Type:JSONObject
                            "text": "语音识别文本"//Type:String语音识别文本
                        },
                    }
                    //InterfaceRequest
                    "request": {//Type:JSONObject
                        "type": "InterfaceRequest",//Type:String
                        "information":{//Type:String
                            "domain":"alarm",//Type:String,接口所属领域
                            "intent":"list",//Type:String,接口所属意图
                            "params":[//Type:JSONArray
                            {
                                "x":"1",
                                "y":"2",
                            }
                            ]//技能接口参数
                        },//请求的接口名称
                    }
                }
              </highlight-code>
    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_bzqq.vue